import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as jsonMenu from '../../../assets/config/menu.json';
import { TranslateService } from '@ngx-translate/core';
import * as jsonLang from '../../../assets/config/lang.json';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input() currentLanguageCode;
  public navItems = jsonMenu.navItems;
  public hamburgerItems = jsonMenu.hamburgerItems;
  public transLang = jsonLang.choice_language;
  public mapLang = new Map<any, any>();

  constructor(private router: Router, public translate: TranslateService, private titleService: Title) {
  }

  ngOnInit() {
    this.mapLang = new Map([
      ['Français', 'fr'],
      ['French', 'fr'],
      ['Anglais', 'en'],
      ['English', 'en'],
    ]);
    this.currentLanguageCode = 'fr';
  }

  redirect(id) {
    switch (id) {
      case 0:
        this.router.navigate(['/signer']);
        break;
      case 1:
        this.router.navigate(['/signer']);
        break;
      case 2:
        this.router.navigate(['/verifier/process']);
        break;
    }
  }

  public closeMenu() {
    if (document.getElementById('sidenav-mobile') != null) {
      document.getElementById('sidenav-mobile').style.width = '0';
    }
    if (document.getElementById('opacity') != null) {
      document.getElementById('opacity').style.display = 'none';
    }
  }

  public setTabTitle(title) {
    this.translate.get(title).subscribe(value => {
      this.titleService.setTitle(value);
    });
  }
}
